import React, { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, Form } from 'semantic-ui-react'
import AuthService from '~/api/services/auth'
import { FormFields } from '~/components/FormFields'
import notify from '~/components/Notify'
import { useAuth } from '~/routes/components/AuthProvider'
import { RouteTypes } from '~/routes/constants'
import { ThemeContext } from 'styled-components';
import LayoutAuth from './LayoutAuth'
import { El } from './style'
import { handleErrors } from '~/utils/helpers'

const TwoFaAuth: React.FC = () => {
  const { t } = useTranslation()
  const { logoTitle, companyName, firstColor, headerTitle } = useContext(ThemeContext)
  const [isBusy, setIsBusy] = useState(false)
  const { handleSubmit, control } = useForm({
    mode: 'onSubmit'
  })
  const navigate = useNavigate()
  const { setIsTfaRequired, setForcePassword, forcePassword, fetchSystemData, tfaType } = useAuth()
  const verificationLabel = getVerificationLabel()

  function getVerificationLabel() {
    switch (tfaType) {
      case 'email':
        return t('E-Mail')
      case 'sms':
        return t('SMS')
      case 'google':
        return t('Authenticator')
      default:
        return ''
    }
  }

  async function onSubmitCode(data) {
    setIsBusy(true)
    try {
      await AuthService.login2FA({
        code: data.code,
        token: localStorage.getItem('token')
      })
      notify(t('The pin code you entered was accepted and you have logged in successfully.'), 'success')
      setIsTfaRequired(false)
      if (!forcePassword) {
        fetchSystemData(true)
      }
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderForm() {
    return <Form
      style={El.loginForm}
      onSubmit={handleSubmit(onSubmitCode)}
      autoComplete={'off'}
    >
      <El.FixedPrice style={{ backgroundImage: `url(${logoTitle})` }} />
      <El.FormLogo style={{ color: firstColor }}>{headerTitle}</El.FormLogo>
      <El.FormHeading style={{ marginBottom: '1rem' }}>
        {t('Enter 2FA code ({{verificationLabel}})', { verificationLabel })}
      </El.FormHeading>
      <FormFields.Input
        control={control}
        rules={{
          required: {
            value: true,
            message: t('Please enter code')
          }
        }}
        placeholder={t('Enter code')}
        name='code'
        label={t('Code')}
      />
      <Form.Group style={{ justifyContent: 'center' }}>
        <Form.Field style={El.loginFormSubmitWrapper}>
          <Button
            style={El.loginFormSubmitButton}
            primary
            content={t('Submit')}
          />
        </Form.Field>
        <Form.Field style={El.loginFormSubmitWrapper}>
          <Button
            onClick={() => {
              setForcePassword(false)
              setIsTfaRequired(false)
              localStorage.removeItem('token')
              navigate(RouteTypes.LOGIN)
            }}
            style={El.loginFormSubmitButton}
            primary
            type='button'
            content={t('Return to login')}
          />
        </Form.Field>
      </Form.Group>
    </Form>
  }

  return <LayoutAuth isLoading={isBusy}>
    {renderForm()}
  </LayoutAuth>

}
export default TwoFaAuth
